module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot5-6e1980445c25d20665f1fa7088d3f932.png";